export default __webpack_public_path__ + "static/media/bg-3938.99952bf3.jpeg";